module.exports = __webpack_public_path__ + "media/images/icons/filled/youtube-028f7545e75398f866063b49c121225f.svg";